import { supabase } from '@/lib/supabase';

export const getAssignedSubprojectsForKpi = async (
  kpiId: number,
): Promise<number[]> => {
  const { data, error } = await supabase
    .from('subproject_view_budget')
    .select('subproject_view_id')
    .eq('kpi_id', kpiId)
    .not('subproject_view_id', 'is', null);

  if (error) {
    throw error;
  }

  return data
    .map((row) => row.subproject_view_id)
    .filter((id): id is number => id !== null);
};
